import croppedLogoBlack from '../assets/images/cropped_logo_black.svg';
import croppedLogoWhite from '../assets/images/cropped_logo_white.svg';

interface Props {
  design: any;
}

const determineLogo = (hexCode: string) => {
  // old color data sometimes have 3 hexcode string for black or white
  // may need to remove (deprecate) this if block once things settle
  if (hexCode === 'FFF' || hexCode === 'FFFFFF') {
    return croppedLogoBlack;
  } else if (hexCode === '000' || hexCode === '000000') {
    return croppedLogoWhite;
  }

  // https://stackoverflow.com/questions/3942878/how-to-decide-font-color-in-white-or-black-depending-on-background-color
  const red = parseInt(hexCode.substring(0, 2), 16);
  const green = parseInt(hexCode.substring(2, 4), 16);
  const blue = parseInt(hexCode.substring(4, 6), 16);
  return red * 0.299 + green * 0.587 + blue * 0.114 > 186
    ? croppedLogoBlack
    : croppedLogoWhite;
};

export const Header: React.FC<Props> = (props) => {
  // if statement required for some reason because sometimes props.design is undefined
  // but it SHOULD always be defined since we load the form (and thus the design object)
  // before loading this component
  const logoSource = determineLogo(
    props.design.colors.background.toUpperCase().substring(1) // substring(1) to get rid of pound sign in hexcode
  );
  return (
    <div className={'header-logo'}>
      <img src={logoSource} alt={'DeloitteDigital'} />
    </div>
  );
};
